<app-header4></app-header4>
<div class="page-title-area page-title-area4">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="banner-content mLText">
                    <span data-animation="fadeInLeft" data-delay="0.5s" class="bienVenu">BIENVENUE À L'ISN POLYSCIENCE</span>
                    <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title">Admission</h1>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- science de la santé -->
<div class="choose-area">
    <div class="container">
        <h3 class="title c-titleDe">DEPARTEMENT SCIENCES DE LA SANTE</h3>
        <div class="row">
            <div class="col-lg-6">
                <div class="choose-cat">
                    <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration=".5s" data-wow-delay=".4s" (click)="admissionMaster('INFIRMIER')">
                        <h4 class="title c-tile">Infirmiers d’Etat</h4>
                        <p class="c-desFormat">Un infirmier est un professionnel de santé, spécialisé dans les soins après une opération. Il agit en étroite collaboration avec les professions médicaux.</p>
                        <i class="fal fa-check iconColor c-colorHover"></i>
                    </div>
                    <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration="1s" data-wow-delay=".6s" (click)="admissionMaster('SAGES-FEMMES')">
                        <h4 class="title c-tile">Sages-femmes d’Etat</h4>
                        <p class="c-desFormat">La sage-femme a pour mission d’accompagner les femmes enceintes tout au long de leur grossesse, de l’établissement du diagnostic jusqu’au jour de l’accouchement. </p>
                        <i class="fal fa-check iconColor"></i>
                    </div>
                    <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration="1s" data-wow-delay=".6s">
                        <h4 class="title c-tile">Assistants infirmiers d’Etat</h4>
                        <p class="c-desFormat">La sage-femme a pour mission d’accompagner les femmes enceintes tout au long de leur grossesse, de l’établissement du diagnostic jusqu’au jour de l’accouchement.</p>
                        <i class="fal fa-check iconColor"></i>
                    </div>
                    <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration="1.5s" data-wow-delay=".8s">
                        <h4 class="title c-tile">Vendeur de pharmacie</h4>
                        <p class="c-desFormat">Le vendeur en pharmacie reçoit, oriente et conseille les clients au sein d’une officine, parfois aussi dans les parapharmacies que l’on peut trouver en grandes surfaces.</p>
                        <i class="fal fa-check iconColor"></i>
                    </div>
                    <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration="1.5s" data-wow-delay=".8s">
                        <h4 class="title c-tile">Secrétaire médicale</h4>
                        <p class="c-desFormat">Le secrétaire médical est un professionnel du secteur de la santé et du social. Au sein de la structure dans laquelle il travaille (hôpital, cabinet médical, centre de cure, laboratoire d’analyses biomédicales ou encore maison
                            de retraite), il est considéré comme le bras droit du médecin.</p>
                        <i class="fal fa-check iconColor"></i>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="choose-thumb-area mt-30">
                    <div class="choose-cat">
                        <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration=".5s" data-wow-delay=".4s" (click)="admissionMaster('GENIE-BIOLOGIQUE')">
                            <h4 class="title c-tile">Licence Biologie médicale</h4>
                            <p class="c-desFormat">La biologie médicale désigne une spécialité médicale qui recourt à des techniques de laboratoire (analyse, microscopie, immunologie, etc.).</p>
                            <i class="fal fa-check iconColor"></i>
                        </div>
                        <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration="1s" data-wow-delay=".6s" (click)="admissionMaster('GENIE-BIOLOGIQUE')">
                            <h4 class="title c-tile">Licence Bio-informatique</h4>
                            <p class="c-desFormat">Le parcours Biologie Informatique de la licence Sciences de la Vie se place dans une perspective pluridisciplinaire associant les domaines des Sciences du Vivant et de l’Informatique.</p>
                            <i class="fal fa-check iconColor"></i>
                        </div>
                        <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration="1.5s" data-wow-delay=".8s">
                            <h4 class="title c-tile">Licence Hygiène, Sécurité et Environnement</h4>
                            <p class="c-desFormat">Hygiène, Sécurité et Environnement, vise la mise en œuvre et l’animation des démarches dans les domaines de la qualité, de l’hygiène, de la sécurité et de l’environnement au sein des entreprises...</p>
                            <i class="fal fa-check iconColor"></i>
                        </div>
                        <div class="choose-cat-item mt-40 wow fadeInLeft c-pointer" data-wow-duration="1.5s" data-wow-delay=".8s">
                            <h4 class="title c-tile">Licence Métiers de la Qualité</h4>
                            <p class="c-desFormat">Cette formation a pour objectif de former des professionnels capables d’animer et de gérer les systèmes de Management Qualité Sécurité et environnement dans tout type d’entreprises...</p>
                            <i class="fal fa-check iconColor"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end science de la santé -->


<!-- science technique -->
<div class="what-we-do-area gray-bg pt-105 pb-120">
    <div class="container">
        <div class="row">
            <div class="col-lg-5 col-md-7">
                <div class="section-title-2">
                    <h2 class="title c-dep ">DEPARTEMENT DES SCIENCES TECHNIQUES ET DE GESTION</h2>
                    <!-- <p>Does any industry face a more complex audience journey and marketing sales process than B2B technology.</p> -->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 c-pointer" (click)="admissionMaster('InformatiqueReseauxIndustriel')">
                <div class="what-we-do-item mt-30">
                    <a>
                        <h6 class="c-tile">Licence en Informatique et Réseaux Industriels </h6><i class="fal fa-long-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 c-pointer" (click)="admissionMaster('LICENCE-STATISTIQUE-INFORMATIQUE-DECISIONNELLE')">
                <div class="what-we-do-item mt-30">
                    <a>
                        <h6 class="c-tile">Licence en Statistique et Informatique Décisionnelle</h6><i class="fal fa-long-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 c-pointer">
                <div class="what-we-do-item mt-30">
                    <a>
                        <h6 class="c-tile">B.T.S Electromécanique </h6><i class="fal fa-long-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 c-pointer">
                <div class="what-we-do-item mt-30">
                    <a>
                        <h6 class="c-tile">Licence Electromécanique </h6><i class="fal fa-long-arrow-right"></i>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 c-pointer" (click)="admissionMaster('GestionAdministrationBien')">
                <div class="what-we-do-item mt-30">
                    <a>
                        <h6 class="c-tile">Licence Gestion et Administration des Biens </h6><i class="fal fa-long-arrow-right"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
<!--end science technique -->



<app-footer2></app-footer2>